export enum CouponType {
  PERCENTAGE = "percentage",
  FIXED = "fixed",
}

export interface Coupon {
  id: string; // ObjectId as string in frontend
  code: string;
  type: CouponType;
  discount: number;
  minOrderAmount: number;
  expiresAt: string; // Date ISO string from backend
  createdAt: string; // Date ISO string
  updatedAt: string; // Date ISO string
}

export interface CreateCouponInput {
  code: string;
  type: CouponType;
  discount: number;
  minOrderAmount: number;
  expiresAt: string; // ISO
}

export interface UpdateCouponInput {
  code?: string;
  type?: CouponType;
  discount?: number;
  minOrderAmount?: number;
  expiresAt?: string; // ISO
}


